export default function beautifyNumber(value) {
  value = parseInt(value);
  if (value < 1e4) {
    return value;
  } else if (value < 1e5) {
    return parseInt(value / 1e2) / 100 + 'w';
  } else if (value < 1e6) {
    return parseInt(value / 1e3) / 10 + 'w';
  } else {
    return parseInt(value / 1e4) + 'w';
  }
}